query GetPossibleProducts($quoteId: ID!) {
    quotePossibleProducts(quote: $quoteId) {
        totalCount
        edges {
            marketPrice {
                amount
                formatted
            }
            node {
                id
                name
                sku
                term
                description
                category {
                    id
                    name
                }
            }
        }
    }
}
